import { SagaIterator } from "redux-saga";
import { call, select, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import {
  deleteCommentById,
  setActionLoading,
  setAnnoucementCount,
  setDocumentCount,
} from "../../repository/slice";
import { selectComments } from "../../repository/selector";
import toast from "react-hot-toast";
import { tokens } from "../../../../locales/tokens";
import i18next from "i18next";

function* deleteCommentWorker({ payload }: any): SagaIterator {
  const { id, type } = payload;

  const url =
    type === "document"
      ? `/api/document-comment/delete-comment`
      : `/api/announcement-comment/delete-comment`;

  try {
    yield put(setActionLoading(true));

    const state = yield select(selectComments);
    const comment = state.comments.find((c: any) => c.id === id);

    const { data, message, isError }: IResponse<any> = yield call(
      requester.post,
      url,
      { id }
    );

    if (!isError) {
      yield put(deleteCommentById(id));
      if (comment && !comment.isReadByAdmin) {
        if (type === "document") {
          yield put(setDocumentCount(state.documentCount - 1));
        } else {
          yield put(setAnnoucementCount(state.annoucementCount - 1));
        }
      }

      toast.success(i18next.t(tokens.comments.successDeleted));
    } else {
      console.error(message);
    }
  } catch (error) {
    console.error("deleteCommentWorker: ", error);
  } finally {
    yield put(setActionLoading(false));
  }
}

export function* deleteCommentWatcher() {
  yield takeLatest("@saga/DELETE_COMMENT", deleteCommentWorker);
}
